import "./App.css";
import { useRef, useState } from "react";
import Tesseract from "tesseract.js";

function App() {
  const [file, setFile] = useState();
  const [progress, setProgress] = useState(0);
  const [language, setLanguage] = useState("eng");
  const [result, setResult] = useState("");
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');
  const textAreaRef = useRef(null);

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
	setCopySuccess(e.target.files[0].name.substring(0, e.target.files[0].name.lastIndexOf('.')) + '.txt' || e.target.files[0].name);
  };
  
  function toggle() {
    setIsOpen((isOpen) => !isOpen);
  }
  
  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand('copy');
    e.target.focus();
  };

  const processImage = (event) => {
    setResult("");
    setProgress(0);
	event.currentTarget.disabled = true;
    Tesseract.recognize(file, language, {
      logger: (m) => {
        if (m.status !== "recognizing text") {
			setIsOpen(!isOpen);
          
        }else{
		  setIsOpen(isOpen);
		  setProgress(m.progress * 100);
		}
		
      },
    }).then(({ data: { text } }) => {
      setResult(text);
    });
  };
  return (
	<div className="image-container">
  <div className="image-wrapper ">
    <div className="local-image-box dropzone d-flex flex-column p-3">
      <div className="d-flex mt-auto mx-auto w-75">
        <div className="row w-100">
          <div className="col">
            <div className="form-group">
              <input type="file" className="form-control" accept=".jpg, .jpeg, .png, .bmp, .webp" onChange={onFileChange} />
            </div>
          </div>
          
        </div>
      </div>
      <div className="d-none d-flex mt-auto flex-end">
        <small className="ms-auto badge bg-cyan-lt cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none">
            </path>
            <path d="M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5">
            </path>
            <path d="M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5">
            </path>
          </svg>Use Remote URL</small>
      </div>
    </div>
    <div className="d-none remote-box d-flex flex-column">
      <div className="d-flex mt-auto mx-auto w-75">
        <div className="row w-100">
          <div className="col">
            <div className="input-group input-group-flat">
              <input type="text" id="remote_url" className="form-control" placeholder="https://..." />
              <span className="input-group-text bg-white">
                <a id="paste" className="link-secondary cursor-pointer" title="Paste" data-bs-toggle="tooltip" data-bs-original-title="Paste">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none">
                    </path>
                    <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2">
                    </path>
                    <rect x="9" y="3" width="6" height="4" rx="2">
                    </rect>
                  </svg>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex mt-auto flex-end">
        <small className="ms-auto badge bg-cyan-lt cursor-pointer">
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none">
            </path>
            <line x1="3" y1="19" x2="21" y2="19">
            </line>
            <rect x="5" y="6" width="14" height="10" rx="1">
            </rect>
          </svg>Upload from device</small>
      </div>
    </div>
  </div>
  
  <div className="mt-3 text-center">
	  {isOpen && <p className="text-warning font-weight-bold loading">Scanning image<span>.</span><span>.</span><span>.</span><span>.</span><span>.</span></p>}
      {!isOpen && <div className="progress"><div className="progress-bar" role="progressbar" style={{width: progress + '%'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div></div>}
      </div>
  
  <div className="form-group my-3">
<div className="form-label">Select language</div>
<select className="form-control" defaultValue={'eng'} onChange={(e) => setLanguage(e.target.value)}>
  <option value="afr">Afrikaans</option>
  <option value="sqi">Albanian</option>
  <option value="amh">Amharic</option>
  <option value="ara">Arabic</option>
  <option value="asm">Assamese</option>
  <option value="aze">Azerbaijani</option>
  <option value="aze_cyrl">Azerbaijani - Cyrillic</option>
  <option value="eus">Basque</option>
  <option value="bel">Belarusian</option>
  <option value="ben">Bengali</option>
  <option value="bos">Bosnian</option>
  <option value="bul">Bulgarian</option>
  <option value="mya">Burmese</option>
  <option value="cat">Catalan; Valencian</option>
  <option value="ceb">Cebuano</option>
  <option value="ces">Czech</option>
  <option value="chi_sim">Chinese - Simplified</option>
  <option value="chi_tra">Chinese - Traditional</option>
  <option value="chr">Cherokee</option>
  <option value="hrv">Croatian</option>
  <option value="dan">Danish</option>
  <option value="nld">Dutch; Flemish</option>
  <option value="dzo">Dzongkha</option>
  <option value="eng">English</option>
  <option value="enm">English (Old)</option>
  <option value="epo">Esperanto</option>
  <option value="est">Estonian</option>
  <option value="fin">Finnish</option>
  <option value="fra">French</option>
  <option value="kat">Georgian</option>
  <option value="kat_old">Georgian - Old</option>
  <option value="deu">German</option>
  <option value="frk">German Fraktur</option>
  <option value="frm">French</option>
  <option value="glg">Galician</option>
  <option value="ell">Greek</option>
  <option value="grc">Greek (Old)</option>
  <option value="guj">Gujarati</option>
  <option value="hat">Haitian; Haitian Creole</option>
  <option value="heb">Hebrew</option>
  <option value="hin">Hindi</option>
  <option value="hun">Hungarian</option>
  <option value="isl">Icelandic</option>
  <option value="ind">Indonesian</option>
  <option value="iku">Inuktitut</option>
  <option value="gle">Irish</option>
  <option value="ita">Italian</option>
  <option value="ita_old">Italian - Old</option>
  <option value="jav">Javanese</option>
  <option value="jpn">Japanese</option>
  <option value="kan">Kannada</option>
  <option value="kaz">Kazakh</option>
  <option value="khm">Central Khmer</option>
  <option value="kir">Kirghiz; Kyrgyz</option>
  <option value="kor">Korean</option>
  <option value="kur">Kurdish</option>
  <option value="lao">Lao</option>
  <option value="lat">Latin</option>
  <option value="lav">Latvian</option>
  <option value="lit">Lithuanian</option>
  <option value="msa">Malay</option>
  <option value="mal">Malayalam</option>
  <option value="mar">Marathi</option>
  <option value="mkd">Macedonian</option>
  <option value="mlt">Maltese</option>
  <option value="meme">Meme</option>
  <option value="nep">Nepali</option>
  <option value="nor">Norwegian</option>
  <option value="ori">Oriya</option>
  <option value="pan">Panjabi; Punjabi</option>
  <option value="fas">Persian</option>
  <option value="pol">Polish</option>
  <option value="por">Portuguese</option>
  <option value="pus">Pushto; Pashto</option>
  <option value="ron">Romanian; Moldavian; Moldovan</option>
  <option value="rus">Russian</option>
  <option value="san">Sanskrit</option>
  <option value="sin">Sinhala; Sinhalese</option>
  <option value="slk">Slovak</option>
  <option value="slv">Slovenian</option>
  <option value="spa">Spanish; Castilian</option>
  <option value="spa_old">Spanish; Castilian - Old</option>
  <option value="srp">Serbian</option>
  <option value="srp_latn">Serbian - Latin</option>
  <option value="swa">Swahili</option>
  <option value="swe">Swedish</option>
  <option value="syr">Syriac</option>
  <option value="tam">Tamil</option>
  <option value="tel">Telugu</option>
  <option value="tgk">Tajik</option>
  <option value="tgl">Tagalog</option>
  <option value="tha">Thai</option>
  <option value="bod">Tibetan</option>
  <option value="tir">Tigrinya</option>
  <option value="tur">Turkish</option>
  <option value="uig">Uighur; Uyghur</option>
  <option value="ukr">Ukrainian</option>
  <option value="urd">Urdu</option>
  <option value="uzb">Uzbek</option>
  <option value="uzb_cyrl">Uzbek - Cyrillic</option>
  <option value="vie">Vietnamese</option>
  <option value="cym">Welsh</option>
  <option value="yid">Yiddish</option>
      </select>
</div>

<div className="form-group my-3">
<button disabled={!copySuccess || (progress !== 0 && progress < 99)} className="btn btn-info mx-auto d-block mt-1" onClick={processImage}>
<span>SCAN</span>
</button>
</div>
{result !== "" && (
<div>
        <div className="form-group position-relative mb-3">
  <textarea id="areaDownload" onChange={(e) => setResult(e.target.value) } value={result} ref={textAreaRef} className="form-control" rows="10" data-gtm-form-interact-field-id="1">
  {result}
  </textarea>
  <a value="copy" onClick={copyToClipboard} className="btn btn-icon cursor-pointer position-absolute top-0 end-0 m-2" title="Copy" data-bs-toggle="tooltip" data-bs-original-title="Copy">
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none">
      </path>
      <rect x="8" y="8" width="12" height="12" rx="2">
      </rect>
      <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2">
      </path>
    </svg>
  </a>
</div>
 <div className="input-group mb-3">
  <input id="namaFile" onChange={(e) => setCopySuccess(e.target.value) } type="text" className="form-control" placeholder="File name" aria-label="File name" aria-describedby="basic-addon2" value={copySuccess} />
  <div className="input-group-append">
    <button id="buttonDownload" className="btn btn-success" type="button">Download</button>
  </div>
</div>  
</div>
    
      )}
	  
	</div> 
	
  );
}

export default App;
